"use client";

import { SheetClose } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { usePathname } from "next/navigation";

type NavbarMobileLinkProps<RouteInferType> = {
  link: __next_route_internal_types__.RouteImpl<RouteInferType>;
  linkClassName?: string;
  className?: string;
  title: string;
  icon?: React.ReactNode;
};

export function NavbarMobileLink<RouteInferType>({
  className,
  title,
  link,
  icon,
  linkClassName,
}: NavbarMobileLinkProps<RouteInferType>) {
  const isInPath = usePathname() === link;

  return (
    <div
      className={cn(
        "-mx-4 flex rounded-xl px-4 py-2 hover:bg-matchbus/20 focus:bg-matchbus/20",
        isInPath && "bg-matchbus/20",
        className,
      )}
    >
      <SheetClose asChild>
        <Link
          href={link}
          rel="noreferrer noopener"
          className={cn(
            "flex w-full flex-row items-center gap-3 text-lg text-offWhite",
            linkClassName,
          )}
        >
          {icon && (
            <span className={isInPath ? "text-matchbus" : ""}>{icon}</span>
          )}{" "}
          {title}
        </Link>
      </SheetClose>
    </div>
  );
}
